import { Component } from 'preact'
import Button from '@insided/control/uikit/Button'
import { isEmailValid } from '@insided/shared/utils/validation'
import { saveModerationNotifications } from './service'

/* eslint-disable import/no-internal-modules */
import Switcher from '@insided/deprecated-preact-components/control/Switcher'
import Header from '@insided/deprecated-control/header'
import Section from '@insided/deprecated-preact-components/design-system-components/section'
import TextField from '@insided/deprecated-preact-components/design-system-components/text-field'
import InputUnit from '@insided/deprecated-preact-components/design-system-components/input-unit'
import Form from '@insided/deprecated-preact-components/design-system-components/form'
import AlertComponent from "@insided/deprecated-control/ui-components/AlertComponent";

export interface ModerationNotificationsProps {
  assignModerator: boolean
  reportedContentEmails: string[]
}

export interface ModerationNotificationsState {
  assignModerator: boolean
  reportedContent: boolean
  reportedContentEmails: Array<{
    email: string
    isValid: boolean
  }>
  showAlert: boolean
}

class ModerationNotifications extends Component<ModerationNotificationsProps, ModerationNotificationsState> {
  constructor(props: ModerationNotificationsProps) {
    super(props)
    this.setInitialState()

    this.setInitialState = this.setInitialState.bind(this)
    this.onSave = this.onSave.bind(this)
    this.toggleAssignModerator = this.toggleAssignModerator.bind(this)
    this.toggleReportedContent = this.toggleReportedContent.bind(this)
    this.addReportedContentEmail = this.addReportedContentEmail.bind(this)
    this.updateReportedContentEmail = this.updateReportedContentEmail.bind(this)
    this.removeReportedContentEmail = this.removeReportedContentEmail.bind(this)
  }

  async onSave() {
    const { assignModerator, reportedContent, reportedContentEmails } = this.state
    const emails = reportedContent ? reportedContentEmails.map(({ email }) => email) : []
    let areEmailsValid = true

    const validatedEmails = reportedContentEmails.map(({ email }) => {
      const isValid = isEmailValid(email)
      if (!isValid) areEmailsValid = false
      return {
        email,
        isValid: isValid
      }
    })

    this.setState({ reportedContentEmails: validatedEmails })

    if (!areEmailsValid) return

    if (emails === []) {
      this.setState({ reportedContent: false })
    }

    try {
      await saveModerationNotifications(assignModerator, emails)
      this.setState({ showAlert: true })
    } catch (e) {}
  }

  toggleAssignModerator() {
    this.setState(({ assignModerator }) => ({ assignModerator: !assignModerator }))
  }

  toggleReportedContent() {
    this.setState(({ reportedContent }) => ({ reportedContent: !reportedContent }))
  }

  addReportedContentEmail() {
    const { reportedContentEmails } = this.state
    reportedContentEmails.push({ email: '', isValid: true })
    this.setState({ reportedContentEmails })
  }

  updateReportedContentEmail(email: string, index: number) {
    const { reportedContentEmails } = this.state
    reportedContentEmails[index].email = email
    this.setState({ reportedContentEmails })
  }

  removeReportedContentEmail(index: number) {
    const { reportedContentEmails } = this.state
    const newEmails = [...reportedContentEmails]
    newEmails.splice(index, 1)
    this.setState({ reportedContentEmails: newEmails})
  }

  setInitialState() {
    this.setState({
      assignModerator: this.props.assignModerator,
      reportedContent: this.props.reportedContentEmails.length > 0,
      reportedContentEmails: this.props.reportedContentEmails.map((email) => ({
        email,
        isValid: true
      })),
      showAlert: false
    })
  }

  render() {
    const { assignModerator, reportedContent, reportedContentEmails, showAlert } = this.state
    return (
      <div>
        {showAlert && (
          <AlertComponent
            sticky
            isVisible
            message='Changes are saved successfully.'
            messageType='success'
            isVisibleFor={3000}
            onTimeoutEnd={() => this.setState({ showAlert: false })}
          />
        )}
        <Header
          title='Moderation notifications'
          saveCallback={this.onSave as () => void}
          cancelCallback={this.setInitialState}
        />
        <Form>
          <Section title='Assign moderator'>
            <Switcher
              label='Send an email notification when a moderator is assigned to a topic'
              on={assignModerator}
              onChange={this.toggleAssignModerator}
              customClass='switcher--full-width qa-assign-moderator'
            />
          </Section>
          <Section title='Reported content'>
            <Form>
              <Switcher
                label='Send an email notification when content is reported'
                on={reportedContent}
                onChange={this.toggleReportedContent}
                customClass='switcher--full-width qa-reported-content'
              />
              {reportedContent && reportedContentEmails.map(({ email, isValid }, index) => {
                return (
                  <div key={index} className='reported-content-email-input'>
                    <InputUnit isControl error={isValid ? undefined : 'Please enter a valid email address.'} label=''>
                      <TextField
                        defaultValue={email}
                        updateInputValue={email}
                        name={`email${index}`}
                        ariaLabel={`email${index}`}
                        id={`email${index}`}
                        onChange={(newEmail) => this.updateReportedContentEmail(newEmail, index)}
                        isControl
                        type='text'
                      />
                    </InputUnit>
                    <Button
                      icon='trash'
                      size='medium'
                      variant='warning'
                      className='qa-add-email'
                      onClick={() => this.removeReportedContentEmail(index)}
                    />
                  </div>
                )})}
              {reportedContent &&
                <Button
                  title='Add email'
                  size='medium'
                  variant='primary'
                  className='qa-add-email'
                  onClick={this.addReportedContentEmail}
                />
              }
            </Form>
          </Section>
        </Form>
      </div>
    )
  }
}

export default ModerationNotifications
